// src/utils/geometry.ts
import * as THREE from 'three';

function createUltrasoundFanOutlineBuffer({
  apexRadiusMm,
  depthMm,
  leftAngleDeg,
  rightAngleDeg,
  arcSegments = 64,
}: {
  apexRadiusMm: number;
  depthMm: number;
  leftAngleDeg: number;
  rightAngleDeg: number;
  arcSegments?: number;
}): THREE.BufferGeometry {
  const points: THREE.Vector3[] = [];

  const innerR = apexRadiusMm;
  const outerR = apexRadiusMm + depthMm;

  const a0 = THREE.MathUtils.degToRad(leftAngleDeg);
  const a1 = THREE.MathUtils.degToRad(rightAngleDeg);

  // Outer arc
  for (let i = 0; i <= arcSegments; i++) {
    const t = i / arcSegments;
    const a = a0 + t * (a1 - a0);
    points.push(new THREE.Vector3(outerR * Math.sin(a), outerR * Math.cos(a), 0));
  }

  // Right radial line (outer → inner)
  points.push(new THREE.Vector3(innerR * Math.sin(a1), innerR * Math.cos(a1), 0));

  // Inner arc (reverse direction)
  for (let i = arcSegments; i >= 0; i--) {
    const t = i / arcSegments;
    const a = a0 + t * (a1 - a0);
    points.push(new THREE.Vector3(innerR * Math.sin(a), innerR * Math.cos(a), 0));
  }

  // Left radial line back to outer arc start
  points.push(new THREE.Vector3(outerR * Math.sin(a0), outerR * Math.cos(a0), 0));

  return new THREE.BufferGeometry().setFromPoints(points);
}

export function createUltrasoundFanOutline() {
  const geometry = createUltrasoundFanOutlineBuffer({
    apexRadiusMm: 7.7,
    depthMm: 110,
    leftAngleDeg: -39.8,
    rightAngleDeg: 39.8,
  });

  const material = new THREE.LineBasicMaterial({
    color: 0xffffff,
    transparent: true,
    opacity: 0.8,
  });

  return new THREE.Line(geometry, material);
}
